import { Link, Card, CardContent, CardHeader, Grid, Paper, Stack } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useContext } from 'react';
import { CreateProductForm } from './CreateProductForm';
import { Link as RouterLink } from 'react-router-dom';
import LightbulbIcon from '@material-ui/icons/Lightbulb';

const useStyles = makeStyles((theme) => ({
  paperForm: {
    padding: 20,
    maxWidth: 600,
    margin: '0 auto'
  },
  gridContainer: {
    padding: 20,
    margin: '0 auto'
  },
  center: {
    textAlign: 'center'
  },
  explain: {
    margin: '0 auto',
    fontSize: 48,
    maxWidth: 600,
    fontFamily: 'Dela Gothic One',
    marginBottom: 5
  },
  separator: {
    marginTop: 50,
    marginBottom: 50,
    backgroundColor: 'darkgray',
    width: '5%',
    height: 5,
    margin: '0 auto',
    display: 'block'
  },
  title: {
    fontFamily: 'Dela Gothic One',
    margin: 0,
    padding: 0
  },
  features: {
    '& .feature': {
      padding: 20,
      margin: '5px 20px'
    },
    '& p': {
      fontSize: 24
    }
  },
  marketingBody: {
    maxWidth: 850,
    margin: '0 auto'
  },
  circled: {
    background: theme.palette.primary.main,
    borderRadius: '0.8em',
    color: '#ffffff',
    display: 'inline-block',
    fontWeight: 'bold',
    lineHeight: '1.6em',
    marginRight: 5,
    textAlign: 'center',
    width: '1.6em',
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0
  }
}));

export const HomeView = ({
  onCreate,
}) => {
  const classes = useStyles();

  return (
    <>
      <Grid className={classes.gridContainer} container spacing={3}>
        <Grid item xs={12}>
          <div className={classes.center}>
            <h2 className={classes.explain}>Sell and buy digital goods on ethereum</h2>
            <p>Create a listing in less than 10 seconds. No gwei required.</p>
          </div>
          <Paper className={classes.paperForm}>
            <CreateProductForm onSave={(product) => onCreate(product)} />
          </Paper>
        </Grid>
      </Grid>

      <div className={classes.separator}></div>

      <div><h1 style={{textAlign: 'center'}}>How's it work?</h1></div>
      <Grid container spacing={6}>
        <Grid item xs={12} sm={4}>
          <div style={{ textAlign: 'center' }}>
            <h2 className={classes.circled}>1</h2>
            <h2 style={{fontWeight: 400}}>Upload a file or some text and get a link.</h2>
          </div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <div style={{ textAlign: 'center' }}>
            <h2 className={classes.circled}>2</h2>
            <h2 style={{fontWeight: 400}}>Share the link with your customers</h2>
          </div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <div style={{ textAlign: 'center' }}>
            <h2 className={classes.circled}>3</h2>
            <h2 style={{fontWeight: 400}}>When customers purchase your product, you get ETH, they get access to your product</h2>
          </div>
        </Grid>
      </Grid>

      <div className={classes.separator}></div>

      <div className={classes.marketingBody}>
        <Grid className={classes.features} container spacing={4}>
          <Grid item xs={12} sm={12}>
            <Card className="feature" variant="outlined">
              <CardContent>
                <h2 className={classes.title}>Start selling immediately.</h2>
                <p>No complicated setup or verifications. Just upload your digital good, you'll get a link you can share to start selling immediately</p>
              </CardContent>
            </Card>

          </Grid>

          <Grid item xs={12} sm={12}>
            <Card className="feature" variant="outlined">
              <CardContent>
                <h2 className={classes.title}>Get paid in ETH, ultra sound money</h2>
                <p>It's all we support, in fact. But finally, you can natively accept ETH, straight to your wallet.</p>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={12}>
            <Card className="feature" variant="outlined">
              <CardContent>
                <h2 className={classes.title}>The lowest transaction fees</h2>
                <p>1.5% per transaction. That's about half or less the cost of any other marketplace.</p>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <div className={classes.separator}></div>

        <div>
          <h1 style={{textAlign: 'center'}}>What can I sell? Lots.</h1>
          <h2 style={{fontWeight: 'normal'}}><LightbulbIcon style={{marginBottom: -4}} /> A special link to access your Discord or Slack server</h2>
          <h2 style={{fontWeight: 'normal'}}><LightbulbIcon style={{marginBottom: -4}} /> Your "12 Rules for staying calm in the crab market"</h2>
          <h2 style={{fontWeight: 'normal'}}><LightbulbIcon style={{marginBottom: -4}} /> A special link to access your ETH technical analysis Google Doc</h2>
          <h2 style={{fontWeight: 'normal'}}><LightbulbIcon style={{marginBottom: -4}} /> Your PDF guide to doing proper due dilligence</h2>
          <h2 style={{fontWeight: 'normal'}}><LightbulbIcon style={{marginBottom: -4}} /> Your workout guide</h2>
          <h2 style={{fontWeight: 'normal'}}><LightbulbIcon style={{marginBottom: -4}} /> A zip file of your pristine dapp development environment</h2>
          <h2 style={{fontWeight: 'normal'}}><LightbulbIcon style={{marginBottom: -4}} /> Your lasagna recipe</h2>
        </div>

        <div className={classes.separator}></div>

        <div>
          <h1 style={{textAlign: 'center'}}>FAQ</h1>
          <h2>How much does it cost?</h2>
          <p>We take a 1.5% transaction fee on any purchase. The lowest transaction fees of any traditional provider. For reference, <a rel="noopener noreferrer" href="https://www.paypal.com/us/webapps/mpp/merchant-fees#fixed-fees-commercialtrans" target="_blank">PayPal</a>: 2.9% + $0.30c, <a href="https://www.shopify.com/pricing" rel="noopener noreferrer">Shopify</a>: 2.9% + $0.30c, <a rel="noopener noreferrer" href="https://squareup.com/us/en/online-store/plans">Square</a>: 2.9% + $0.30, Gumroad: 3.5% + $0.30. How is it so much cheaper? Transacting on Ethereum is cheap. TradFi isn't. We still have some costs though. We have to store your files, handle the transactions and create a nice marketplace experience.</p>

          <h2>Will you support bitcoin?</h2>
          <p>We'd like to.</p>
        </div>
      </div>

    </>
  );
};
